import FieldConfig from "../../../proto/field-config"
import FieldEstimatedCost from "./estimated-cost"
import {EntityType} from "../../../../gd/const/item";

export default class FieldEstimatedCostInternal extends FieldEstimatedCost {

    constructor(config:FieldConfig) {
        super(config)

        this.typeLabel          = "Estimated labor cost"
        this.typeDescription    = "Estimated labor cost field"

        this.label              = _.get(config, 'label', this.typeLabel)


        switch (this.entityType) {
            case EntityType.PROJECT:
                this.variableName       = '{PROJECT-ESTIMATED-LABOR-COST}'
                break
        }

    }
}
